import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';
import { IconSize } from '../SVGIcon';

type FluentUISystemIconClassNames = ComponentClassNames<'fluentUISystemIcon'>;

export const getClassNames = memoizeFunction(
  (
    block: boolean,
    color: string | undefined,
    size: IconSize | undefined,
    className?: string
  ): FluentUISystemIconClassNames => {
    const lineHeight = block ? 0 : undefined;
    const iconSize = size ? `${size}px !important` : undefined;

    return mergeStyleSets({
      fluentUISystemIcon: [
        // Need to keep this class name for proper sizing when nested under Block or Text.
        'y-fluent-icon',
        {
          display: block ? 'block' : 'inline',
          verticalAlign: 'middle',
          fill: 'currentColor',
          color,
          lineHeight,
          height: iconSize,
          width: iconSize,

          /* IE/Edge do not bubble click events up from SVG elements, so allow clicks to pass through */
          pointerEvents: 'none',

          '& > .svg': {
            height: iconSize,
            width: iconSize,
            lineHeight,
          },
        },
        className,
      ],
    });
  }
);
